<template>
  <div>
    <hg-dialog title="新增用户" :width="600" :height="400" :visible.sync="dialogVisible" @close="handleClose">
      <el-form :model="data" size="mini"  :rules="rules" ref="ruleForm" label-width="120px" class="add-box">
        <el-row :gutter="22">
          <el-col :span="22">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="data.username" maxlength="50" placeholder="请输入用户名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="昵称" prop="username">
              <el-input v-model="data.nickName" maxlength="50" placeholder="请输入昵称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="22">
            <el-form-item label="密码" prop="password">
              <el-input v-model="data.password" type="password" maxlength="50" placeholder="请输入密码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="data.sex" placeholder="请选择性别">
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="22">
            <el-form-item label="联系方式1" prop="phoneOne">
              <el-input v-model="data.phoneOne" maxlength="11" placeholder="请输入联系方式1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="联系方式2" prop="phoneTwo">
              <el-input v-model="data.phoneTwo" maxlength="11" placeholder="请输入联系方式2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="22">
            <el-form-item label="身份证号" prop="userId">
              <el-input v-model="data.userId" maxlength="18" placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="排序号" prop="sort">
              <el-input v-model="data.sort" maxlength="8" placeholder="请输入排序号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="22">
            <el-form-item label="查询前缀" prop="select">
              <el-input v-model="data.select" maxlength="50" placeholder="请输入查询前缀"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="角色" prop="roleId">
              <el-select v-model="roleArr"
                         filterable
                         multiple
                         placeholder="请选择角色">
                <el-option
                  v-for="item in allRoleList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="22">
            <el-form-item label="是否启用" prop="select">
              <el-switch
                v-model="data.statu"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="depart-list">
        <list @toSelect="toSelect"
              @defaultSelect="defaultSelect"
              v-if="dialogVisible"
              :departId="data.departId"
              :defaultDepart="defaultDepart"/>
      </div>
      <span slot="footer" style="width:100%;text-align: right">
        <el-button type="primary" @click="submit" size="small" icon="el-hg-icon-save">保 存</el-button>
        <el-button @click="handleClose" size="small" icon="el-hg-icon-close">关 闭</el-button>
      </span>
    </hg-dialog>
  </div>
</template>
<script>
import list from '../comm/list';
import HgDialog from '@/components/dialog';

export default {
  name: 'add',
  components: {
    list,
    HgDialog
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    allRoleList: {
      type: Array
    }
  },
  data() {
    return {
      dialogVisible: false,
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        nickName: [{
          required: true,
          message: '请输入昵称',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        roleId: [{
          required: true,
          message: '请选择角色',
          trigger: 'blur'
        }]
      },
      data: {
        username: '',
        sex: 1,
        password: '',
        nickName: '',
        phoneOne: '',
        phoneTwo: '',
        userId: '',
        sort: '',
        select: '',
        roleId: '',
        defaultDepart: '',
        departId: '',
        updateFlg: 'add'
      },
      roleArr: [],
      departArr: [],
      defaultDepart: '',
      departId: ''
    };
  },
  methods: {
    toSelect(departId) {
      if (this.departArr.indexOf(departId) > -1) {
        this.departArr.splice(this.departArr.indexOf(departId), 1);
      }
      else {
        this.departArr.push(departId);
      }
    },
    defaultSelect(defaultDepart) {
      this.data.defaultDepart = defaultDepart;
    },
    submit() {
      this.data.roleId = this.roleArr.join(',');
      this.data.departId = this.departArr.join(',');
      this.data.defaultDepart = this.data.defaultDepart ? this.data.defaultDepart : this.defaultDepart;
      this.data.status = this.data.statu? 1 : 0;
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          if (this.data.departId === '') {
            this.$toaster.error('请选择所在部门');
            return;
          }
          if (this.data.defaultDepart === '') {
            this.$toaster.error('请选择默认部门');
            return;
          }
          this.saveUser();
        }
        else {
          return false;
        }
      });
    },
    async saveUser() {
      const res = await this.$services.postJson({
        type: 'USERMANGEMENT',
        url: 'saveUser',
        params: JSON.parse(JSON.stringify(this.data))
      });
      if (res.code === '000') {
        this.$toaster.ok('保存成功');
        this.handleClose();
        this.$emit('refresh');
      }
      else {
        this.$toaster.error(res.msg);
      }
    },
    handleClose() {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      this.roleArr = [];
      this.$emit('close');
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
      }
    }
  }
};
</script>
<style lang="scss">
.depart-list {
  padding: 0 30px;
}
</style>
